
const digest = '7d73b4a752b129e962b6786f423e65f5266432a3ad7f4368db8c0a34da02a611';
const classes = {"wrapper":"_wrapper_u5ey4_1","bullet":"_bullet_u5ey4_7","icon":"_icon_u5ey4_12"};
const css = `._wrapper_u5ey4_1 {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
}
._wrapper_u5ey4_1 ._bullet_u5ey4_7 {
  height: 10px;
  width: 10px;
  border-radius: 100%;
}
._wrapper_u5ey4_1 ._icon_u5ey4_12 {
  height: 18px;
  margin-bottom: 2px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  